import * as apiLocal from '../_api/api_local.json';
import * as apiDev from '../_api/api_dev.json';
import * as apiStg from '../_api/api_stg.json';
import * as apiPreProd from '../_api/api_preprod.json';
import * as apiProd from '../_api/api_prod.json';
import * as util from '../common/js/util';
import { Operator, Bandwidth, Technology, CustomerType } from '../model/fbb/FbbEnum';

export class API {
	static api?: any;
	static error?: any;

	static setup() {
		if (util.isLocal()) {
			//apiLocal.default.api
			API.api = apiLocal.api;
			API.error = apiLocal.error;
		} else if (util.isDev()) {
			API.api = apiDev.api;
			API.error = apiDev.error;
		} else if (util.isStg()) {
			API.api = apiStg.api;
			API.error = apiStg.error;
		} else if (util.isPreProd()) {
			API.api = apiPreProd.api;
			API.error = apiPreProd.error;
		} else if (util.isProd()) {
			API.api = apiProd.api;
			API.error = apiProd.error;
		}
	}

	static parseOperator(operator: string): Operator {
		if (operator === 'HKBN') {
			return Operator.hkbn;
		} else if (operator === 'HGC') {
			return Operator.hgc;
		} else if (operator === 'ICABLE' || operator === 'CABLE') {
			return Operator.icable;
		}
		return Operator.hkbn;
	}

	static parseBandwidth(bandwidth: string): Bandwidth {
		if (bandwidth === '1000') {
			return Bandwidth.b1000;
		} else if (bandwidth === '100') {
			return Bandwidth.b100;
		} else if (bandwidth === '200') {
			return Bandwidth.b200;
		} else if (bandwidth === '2000') {
			return Bandwidth.b2000;
		} else if (bandwidth === '500') {
			return Bandwidth.b500;
		} else {
			return Bandwidth.b1000;
		}
	}

	static parseCustomerType(type: string): CustomerType {
		if (type === 'SMC') {
			return CustomerType.SMC;
		} else if (type === 'MASS') {
			return CustomerType.MASS;
		}
		return CustomerType.MASS;
	}

	static parseTechnology(tech: string): Technology {
		if (tech === 'DOS') {
			return Technology.DOS;
		} else if (tech === 'GP') {
			return Technology.GP;
		} else if (tech === 'ME') {
			return Technology.ME;
		}
		return Technology.GP;
	}
}
